import { render, staticRenderFns } from "./window-frame.global.vue?vue&type=template&id=38f23e92&functional=true&"
import script from "./window-frame.global.vue?vue&type=script&lang=js&"
export * from "./window-frame.global.vue?vue&type=script&lang=js&"
import style0 from "./window-frame.global.vue?vue&type=style&index=0&id=38f23e92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports